module.exports = __webpack_public_path__ + "static/media/teleprospection.2f7c53c1.jpg";